var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeeklyDrawBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2946 10.446C20.1231 9.99446 19.6903 9.69591 19.2073 9.6959L13.6095 9.69591L13.6095 6.49581C13.6082 6.29315 13.5525 6.09456 13.4482 5.92078C13.344 5.747 13.1949 5.60443 13.0167 5.50796C12.8385 5.41148 12.6376 5.36466 12.4351 5.37237C12.2325 5.38008 12.0358 5.44204 11.8654 5.55179C8.00007 7.22494 5.98058 8.44809 2.62518 11.1279C2.30727 11.3819 2.07943 11.7066 2.07943 12.096C2.07943 12.4853 2.35298 12.8098 2.62518 13.064C5.85303 16.0788 7.88267 17.2914 11.8654 18.6402C12.0375 18.7431 12.2339 18.7984 12.4343 18.8005C12.6348 18.8025 12.8323 18.7513 13.0064 18.652C13.1806 18.5527 13.3253 18.4089 13.4256 18.2353C13.526 18.0618 13.5784 17.8646 13.5775 17.6641V14.464L19.3123 14.464C19.7179 14.464 20.0865 14.2282 20.2565 13.86C20.7249 12.8452 20.7651 11.6846 20.3682 10.6398L20.2946 10.446Z",
    fill: "#FFB07B",
    stroke: "#1D202B",
    strokeWidth: 1.76471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeeklyDrawBackBtn);
export default __webpack_public_path__ + "static/media/weekly-draw-back-btn.93abf552e0f5c264ac3abd4e97a97c01.svg";
export { ForwardRef as ReactComponent };